import { useEffect, useState } from 'react'

const useCounter = (initialValue) => {
    const [count, setCount] = useState(initialValue ? initialValue : 60)
    const [isOff, setIsOff] = useState(true)


    useEffect(() => {
        const interval = setInterval(() => {
            if (count > 0) {
                setCount(count => count - 1)
            } else {
                setIsOff(false)
            }
        }, 1000)
        return () => clearInterval(interval)
    }, [count])

    const resetCounter = () => {
        setCount(initialValue)
        setIsOff(true)
    }

    return { count, isOff, resetCounter, setCount, setIsOff}
}

export default useCounter
